import { DataType } from "components/containers/inspectionSetting/containers/templateBuilder/setup/define";
import dayjs from "config/dayjs";

const DEFAULT_DAY_FOR_DATE_FORMAT_OPTIONS = "2025-02-28";

export const DEFAULT_DATE_FROM_PHOTO_ID = "";
export const DEFAULT_DATE_FROM_PHOTO_LABEL = "デフォルト値を設定しない";

export enum DateFormatType {
  "M_D",
  "M_D_E",
  "YYYY_M_D",
  "YYYY_MM_DD",
  "YYYY/M/D",
  "YYYY/MM/DD",
}

export const DATE_PICKER_FORMAT_STRING = {
  [DateFormatType.M_D]: "M月d日",
  [DateFormatType.M_D_E]: "M月d日 (E)",
  [DateFormatType.YYYY_M_D]: "yyyy年M月d日",
  [DateFormatType.YYYY_MM_DD]: "yyyy年MM月dd日",
  [DateFormatType["YYYY/M/D"]]: "yyyy/M/d",
  [DateFormatType["YYYY/MM/DD"]]: "yyyy/MM/dd",
};

export const DAYJS_FORMAT_STRING = {
  [DateFormatType.M_D]: "M月D日",
  [DateFormatType.M_D_E]: "M月D日 (dd)",
  [DateFormatType.YYYY_M_D]: "YYYY年M月D日",
  [DateFormatType.YYYY_MM_DD]: "YYYY年MM月DD日",
  [DateFormatType["YYYY/M/D"]]: "YYYY/M/D",
  [DateFormatType["YYYY/MM/DD"]]: "YYYY/MM/DD",
};

const defaultDayObj = dayjs(DEFAULT_DAY_FOR_DATE_FORMAT_OPTIONS);

export const DATE_FORMAT_OPTIONS = [
  {
    label: defaultDayObj.format(DAYJS_FORMAT_STRING[DateFormatType.M_D]),
    value: DateFormatType.M_D,
  },
  {
    label: defaultDayObj.format(DAYJS_FORMAT_STRING[DateFormatType.M_D_E]),
    value: DateFormatType.M_D_E,
  },
  {
    label: defaultDayObj.format(DAYJS_FORMAT_STRING[DateFormatType.YYYY_M_D]),
    value: DateFormatType.YYYY_M_D,
  },
  {
    label: defaultDayObj.format(DAYJS_FORMAT_STRING[DateFormatType.YYYY_MM_DD]),
    value: DateFormatType.YYYY_MM_DD,
  },
  {
    label: defaultDayObj.format(
      DAYJS_FORMAT_STRING[DateFormatType["YYYY/M/D"]]
    ),
    value: DateFormatType["YYYY/M/D"],
  },
  {
    label: defaultDayObj.format(
      DAYJS_FORMAT_STRING[DateFormatType["YYYY/MM/DD"]]
    ),
    value: DateFormatType["YYYY/MM/DD"],
  },
];

export enum TimeFormatType {
  "HH:mm",
}

export const TIME_PICKER_FORMAT_STRING = {
  [TimeFormatType["HH:mm"]]: "HH:mm",
};

export const TIME_FORMAT_OPTIONS = [
  { label: "HH:mm", value: TimeFormatType["HH:mm"] },
];

export const DAYJS_TIME_FORMAT_STRING = {
  [TimeFormatType["HH:mm"]]: "HH:mm",
};

export type TimeAdditionalInfo = {
  formatType: TimeFormatType;
};

export type GetInspectionItemResultList = {
  inspectionTypeId: string;
  shouldCache?: boolean;
};

export type MapValuesAdditionalInfo = {
  label: string;
  displayValue: string;
};
export type CheckboxAdditionalInfo = {
  mapValues: Record<string, MapValuesAdditionalInfo>;
};
export type DateFromPhotoOptions = {
  id: string;
  index: number;
  total: number;
  name: string;
  isDefault?: boolean;
};
export type DateAdditionalInfo = {
  formatType: DateFormatType;
  dateFromPhotoId?: string;
};

export type AdditionInfo = {
  checkbox?: CheckboxAdditionalInfo;
};
export type PreFilledAdditionInfo = {
  value?: string;
};

export interface InspectionItemResult<AdditionInfo = any> {
  id: string;
  offlineId?: string;
  contentItemId: string;
  name: string;
  dataType: DataType;
  additionInfo?: AdditionInfo | null;
  order?: string;
  createdAt?: Date;
  updatedAt?: Date;
}
